import {Initialize} from 'pacto';
import {Vimeoplayer} from 'modules/generic/vimeoplayer/views/Vimeoplayer';
import {Loader} from 'modules/generic/vimeoplayer/services/Loader';


const loader = new Loader();


export class Action extends Initialize {

	get settings() {
		return {
			selector: '.vimeoplayer',
			namespace: 'vimeoplayer:views',
			view: Vimeoplayer,
			params: {loader}
		};
	}

}
